module.exports = __webpack_public_path__ + "img/xwzx_mobile_card.500e2dd6.png";